import { find } from 'lodash/fp';

import { BreakpointRange } from '../enums';
import { BreakpointRangeValue } from '../enums/types';

export const getBreakpointRange = (): BreakpointRangeValue =>
    find((b) => window.matchMedia(`(min-width: ${b.low}px) and (max-width: ${b.high}px)`).matches, BreakpointRange) ||
    BreakpointRange.Phone;
